export const memberFormUpdate = ({ prop, value }) => {

    return {
        type: 'MEMBER_FORM_UPDATE',
        field: { prop, value }
    };
};

export const memberFormError = (message) => {

    return {
        type: 'MEMBER_FORM_ERROR',
        message
    };
};

export const memberFormSuccess = (message) => {

    return {
        type: 'MEMBER_FORM_SUCCESS',
        message
    };
};

export const memberFormReset = () => {
    
    return {
        type: 'MEMBER_FORM_RESET',
    };
}